import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import CryptogramUploadFile from "./CryptogramUploadFile";
import ServiceManagement from "./ServiceManagement";
import MasterKeyBinding from "./MasterKeyBinding";
import Encryption from "./Encryption";
import MacMasterKeyBinding from "../MacKeyManagement/MacMasterKeyBinding";
import MacEncryption from "../MacKeyManagement/MacEncryption";


function KeyManagementTabs(props) {
    const [activeTab, setActiveTab] = useState(1);
    const [path, setPath] = useState();
    const history = useHistory();
    const location = useLocation();
    const tabs = [
        {
            name: "PIN Crypotogram File",
            path: "/keyManagement",
        },
        {
            name: "PIN MasterKey Binding",
            path: "/keyManagement/masterKeyBind",
        },
        {
            name: "PINEncryption",
            path: "/keyManagement/encryption",
        },
        {
            name: "MAC MasterKey Binding",
            path: "/keyManagement/macMasterKeyBind",
        },
        {
            name: "MACEncryption",
            path: "/keyManagement/macEncryption",
        },
    ];
    useEffect(() => {
        setPath(location.pathname);
    }, [location.pathname]);

    const renderTab = () => {
        if (path === "/keyManagement") {
            return <CryptogramUploadFile />;
        } else if (path === "/keyManagement/serviceMgmt") {
            return <ServiceManagement />
        } else if (path === "/keyManagement/masterKeyBind") {
            return <MasterKeyBinding />;
        } else if (path === "/keyManagement/encryption") {
            return <Encryption />;
        }else if (path === "/keyManagement/macMasterKeyBind") {
            return <MacMasterKeyBinding />;
        } else if (path === "/keyManagement/macEncryption") {
            return <MacEncryption />;
        }
    }

    return (
        <>
            <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
                {tabs.map((tab, index) => (
                    <li className="nav-item">
                        <a
                            className={`nav-link ${path === tab.path && "active"}`}
                            data-toggle="tab"
                            href="#tb_key_mgmt"
                            role="tab"
                            onClick={() => history.push(`${tab.path}`)}
                        >
              <span className="d-block d-sm-none">
                <i className="fas fa-address-card"></i>
              </span>
                            <span
                                className="d-none d-sm-block"
                                style={{ whiteSpace: "pre-line" }}
                            >
                {tab.name}
              </span>
                        </a>
                    </li>
                ))}
            </ul>
            <div className="tab-pane" role="tabpanel">
                {renderTab()}
            </div>
        </>
    );
}

export default KeyManagementTabs;
